<template>
  <va-card :title="$t('payments.sources.heading')">
    <va-data-table
      :fields="fields"
      :data="SourcesSites"
      :rowClass="rowClass"
      :per-page="20"
      :loading="loading"
      @row-clicked="editSource"
      no-pagination
    >
    </va-data-table>
    <va-button class="add-button" @click="showLargeModal = true">
      {{ $t('payments.list.addButton') }}</va-button
    >
    <va-modal
      v-model="showLargeModal"
      class="modal"
      size="large"
      @cancel="canncelModal"
      :noOutsideDismiss="true"
      @ok="okModal"
    >
      <va-input
        v-model="cacheSource.domain_name"
        :placeholder="$t('payments.sources.domain_name')"
      />
      <va-input
        v-model="cacheSource.auth_username"
        :placeholder="$t('payments.sources.auth_username')"
      />
      <va-input
        v-model="cacheSource.auth_password"
        :placeholder="$t('payments.sources.auth_password')"
      />
      <va-color-picker-input mode="advanced" v-model="cacheSource.color">
        <va-color-square :value="cacheSource.color" />
      </va-color-picker-input>
      <va-toggle class="is_enabled" v-model="cacheSource.is_enabled" small />
      <!-- @input="cacheSource.is_enabled" -->
      <va-button
        class="is_enabled"
        v-if="!cacheSource.is_enabled"
        @click="removeSource(cacheSource.id)"
        flat
        small
      >
        {{ $t('tables.delete') }}
      </va-button>
    </va-modal>
  </va-card>
</template>

<script>
export default {
  data () {
    return {
      showLargeModal: false,
      cacheSource: {
        id: '',
        domain_name: '',
        auth_username: '',
        is_enabled: true,
        color: '#000',
      },
    }
  },
  computed: {
    fields () {
      return [
        {
          name: 'id',
          title: this.$t('payments.sources.id'),
        },
        {
          name: 'domain_name',
          title: this.$t('payments.sources.domain_name'),
        },
        {
          name: 'auth_username',
          title: this.$t('payments.sources.auth_username'),
        },
      ]
    },
    SourcesSites () {
      return this.$store.getters.SourcesSites
    },
    loading () {
      return this.SourcesSites.length < 1
    },
  },
  methods: {
    async removeSource (id) {
      if (id) {
        await this.$store.dispatch('deleteSourceSite', id)
      }
      this.cacheSourceClear()
    },
    okModal () {
      const NewSource = Object.assign({}, this.cacheSource)
      if (NewSource.id) {
        this.$store.dispatch('updateSourceSite', NewSource)
      } else {
        this.$store.dispatch('addSourceSite', NewSource)
      }
      this.cacheSourceClear()
    },
    canncelModal () {
      this.cacheSourceClear()
    },
    cacheSourceClear () {
      for (const key in this.cacheSource) {
        if (Object.hasOwnProperty.call(this.cacheSource, key)) {
          this.cacheSource[key] = ''
        }
      }
      this.cacheSource.is_enabled = true
    },
    cacheSourceSet (obj) {
      for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
          this.cacheSource[key] = obj[key]
        }
      }
    },
    editSource (source) {
      this.cacheSourceSet(source)
      this.showLargeModal = true
    },
    rowClass (source, index) {
      return source.is_enabled ? 'sources work' : 'sources not-work'
    },
  },
  created () {
    this.$store.dispatch('getSourcesSites')
    this.$store.dispatch('getPaymentsMethods')
  },
}
</script>

<style lang="scss">
.sources {
  cursor: pointer;
}

.not-work {
  td {
    color: $dropdown-background;
    background-color: $theme-danger !important;
  }
}

.va-modal__inner {
  min-width: 500px;
}
</style>
